// extracted by mini-css-extract-plugin
export default {"container":"projects_container__gPjNw","row":"projects_row__9Jw34","wrapper":"projects_wrapper__Iazwu","title":"projects_title__kEru7","idWrapper":"projects_idWrapper__CYqlg"};